var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 24.5,
    height: 24.5,
    rx: 12.25,
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.4894C12.2936 18.4867 12.0965 18.4035 11.9506 18.2576C11.8046 18.1117 11.7214 17.9145 11.7188 17.7082V10.4165C11.7188 10.2093 11.8011 10.0106 11.9476 9.86408C12.0941 9.71756 12.2928 9.63525 12.5 9.63525C12.7072 9.63525 12.9059 9.71756 13.0524 9.86408C13.1989 10.0106 13.2812 10.2093 13.2812 10.4165V17.7082C13.2786 17.9145 13.1954 18.1117 13.0494 18.2576C12.9035 18.4035 12.7064 18.4867 12.5 18.4894ZM12.5 8.59359C12.2936 8.59089 12.0965 8.50771 11.9506 8.36178C11.8046 8.21585 11.7214 8.0187 11.7188 7.81234V7.2915C11.7188 7.0843 11.8011 6.88559 11.9476 6.73908C12.0941 6.59256 12.2928 6.51025 12.5 6.51025C12.7072 6.51025 12.9059 6.59256 13.0524 6.73908C13.1989 6.88559 13.2812 7.0843 13.2812 7.2915V7.81234C13.2786 8.0187 13.1954 8.21585 13.0494 8.36178C12.9035 8.50771 12.7064 8.59089 12.5 8.59359Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayInfo);
export default __webpack_public_path__ + "static/media/grayInfo.f23b38cbfdb5646f0cffc960f2daf07f.svg";
export { ForwardRef as ReactComponent };